export default __webpack_public_path__ + "static/media/ru.764a16d2.svg";